import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const Home03Icon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon {...props} viewBox="0 0 22 21">
    <path
      d="M7.75 19.5V12.1C7.75 11.5399 7.75 11.2599 7.859 11.046C7.95487 10.8578 8.10785 10.7049 8.29601 10.609C8.50993 10.5 8.78995 10.5 9.35 10.5H12.15C12.7101 10.5 12.9901 10.5 13.204 10.609C13.3922 10.7049 13.5451 10.8578 13.641 11.046C13.75 11.2599 13.75 11.5399 13.75 12.1V19.5M0.75 8L9.79 1.22C10.1343 0.961806 10.3064 0.832709 10.4954 0.782945C10.6623 0.739018 10.8377 0.739018 11.0046 0.782945C11.1936 0.832709 11.3657 0.961806 11.71 1.22L20.75 8M2.75 6.5V16.3C2.75 17.4201 2.75 17.9802 2.96799 18.408C3.15974 18.7843 3.4657 19.0903 3.84202 19.282C4.26985 19.5 4.8299 19.5 5.95 19.5H15.55C16.6701 19.5 17.2302 19.5 17.658 19.282C18.0343 19.0903 18.3403 18.7843 18.532 18.408C18.75 17.9802 18.75 17.4201 18.75 16.3V6.5L12.67 1.94C11.9815 1.42361 11.6372 1.16542 11.2591 1.06589C10.9254 0.978037 10.5746 0.978037 10.2409 1.06589C9.86278 1.16542 9.51852 1.42361 8.83 1.94L2.75 6.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SvgIcon>
);
